export function setSeoTitle(entrepriseName, mainPage, section = "", detail = "") {
  document.title =
    entrepriseName + ` - ${mainPage}` +
    `${section ? " | " + section : ""}${detail ? " : " + detail : ""}`;
}
